/**
 *
 * Asynchronously loads the component for Surveys
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'), {
  fallback: null,
});
